import siteConfig from "site-config";

export const getLinkedRetailer = () => ({
    url: `${siteConfig.api}/retailers/get/linked`,
    force: true,
    options: {
        method: "GET",
    },
    transform: (response) => {
        return { retailer: response.retailer };
    },
});

export const requestAccess = (brandId, data) => ({
    url: `/api/v3.0/brand/${brandId}/connection-requests`,
    force: true,
    options: {
        method: "POST",
    },
    body: data,
});
